function readSession() {
  try {
    const data = JSON.parse(localStorage.getItem('currentUser') || 'null');
    const token = data?.token?.replace(/^Bearer /, '');
    const payload = token ? JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))) : null;
    if (payload?.exp * 1000 > Date.now() && Number.isInteger(payload.version)) return { ...data, loading: false };
  } catch (_) { /* Sesión ausente o corrupta: solicitar acceso de nuevo. */ }
  localStorage.removeItem('currentUser');
  return { user: null, token: null, loading: false };
}
export const initialState = readSession();
export function AuthReducer(state, action) {
  switch (action.type) {
    case 'REQUEST_LOGIN': return { ...state, loading: true };
    case 'LOGIN_SUCCESS': return { ...action.payload, loading: false };
    case 'LOGOUT': return { user: null, token: null, loading: false };
    case 'SET_ERROR': return { ...state, loading: false, error: action.payload };
    default: return state;
  }
}
